import React from "react";

export default function ShinyText({ children, className = "" }) {
  return <span className={`fk-shiny-text ${className}`}>{children}</span>;
}

